import Equipment from "./equipment";
export default Equipment